import { useQuery } from 'react-query'
import { QueryKeyEnum } from '../../enums/QueryKeyEnum'
import { api } from '../api'
import { AssistantThead } from 'shared'

export const useGetThreads = () => {
  return useQuery({
    queryKey: [QueryKeyEnum.THREADS],
    queryFn: () => api.get<{ data: AssistantThead[] }>('/ai/assistant/thread'),
  })
}
